import React, { useCallback, useState } from "react";
import { motion } from "framer-motion";
import emailjs from "@emailjs/browser";
import { styles } from "../styles";
import { EarthCanvas } from "./canvas";
import { SectionWrapper } from "../hoc";
import { slideIn } from "../utils/motion";

const INITIAL_FORM_STATE = {
  name: "",
  email: "",
  message: "",
};

const Contact = () => {
  const [form, setForm] = useState(INITIAL_FORM_STATE);
  const [loading, setLoading] = useState(false);

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  }, []);

  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      setLoading(true);
      try {
        await emailjs.send(
          "service_lhmd1ms",
          "template_vnxs5la",
          {
            from_name: form.name,
            to_name: "JaberSaid",
            from_email: form.email,
            to_email: "jaberthic@gmail.com",
            message: form.message,
          },
          "qZzeUMaAIezXUc7mG"
        );
        setLoading(false);
        alert("Thank you. I will get back to you as soon as possible.");
        setForm(INITIAL_FORM_STATE);
      } catch (error) {
        setLoading(false);
        console.error(error);
        alert("Oops, something went wrong. Please try again.");
      }
    },
    [form]
  );

  return (
    <div className="xl:mt-12 flex xl:flex-row flex-col-reverse gap-10 overflow-hidden">
      <motion.div
        variants={slideIn("left", "tween", 0.2, 1)}
        className="flex-[0.75] bg-black-100 p-8 rounded-2xl"
      >
        <p className={`${styles.sectionSubText} text-center`}>Get in touch</p>
        <h3 className={`${styles.sectionHeadText} text-center mb-8 magic-tex`}>
          Contact.
        </h3>

        <form onSubmit={handleSubmit} className="mt-12 flex flex-col gap-8">
          <FormField
            label="Your Name"
            name="name"
            type="text"
            value={form.name}
            onChange={handleChange}
            placeholder="What's your name?"
          />
          <FormField
            label="Your Email"
            name="email"
            type="email"
            value={form.email}
            onChange={handleChange}
            placeholder="What's your email address?"
          />
          <FormField
            label="Your Message"
            name="message"
            as="textarea"
            rows={7}
            value={form.message}
            onChange={handleChange}
            placeholder="What would you like to say?"
          />
          <button
            type="submit"
            className="bg-tertiary py-3 px-8 rounded-xl outline-none w-fit text-white font-bold shadow-md shadow-primary transition-all duration-300 ease-in-out hover:bg-opacity-80 mx-auto"
            disabled={loading}
          >
            {loading ? "Sending..." : "Send Message"}
          </button>
        </form>
      </motion.div>

      <motion.div
        variants={slideIn("right", "tween", 0.2, 1)}
        className="xl:flex-1 xl:h-auto md:h-[550px] h-[350px]"
      >
        <EarthCanvas />
      </motion.div>
    </div>
  );
};

const FormField = ({ label, as: Component = "input", ...props }) => (
  <label className="flex flex-col">
    <span className="text-white font-medium mb-4">{label}</span>
    <Component
      className="bg-tertiary py-4 px-6 placeholder:text-secondary text-white rounded-lg outline-none border-none font-medium transition-all duration-300 ease-in-out focus:ring-2 focus:ring-white"
      {...props}
    />
  </label>
);

export default SectionWrapper(Contact, "contact");
